import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "@/plugins/vuetify";
import axios from "axios";

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import { TitleComponent, GridComponent } from "echarts/components";

import ECharts from "vue-echarts";

import VueShepherd from 'vue-shepherd';

Vue.use(VueShepherd);

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

Vue.config.productionTip = false;

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    Vue,
    dsn: "https://31b9ddc6d8ad4f389f59c289b1f3ccb8@sentry.spicetech.de/10",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    environment: process.env.VUE_APP_SENTRY_ENV,
    logErrors: true
  });
}

window.EventBus = new Vue();

window.vueDevMode = process.env.NODE_ENV;
window.serverUrl = location.protocol + "//" + location.host;
window.actionUrl = window.serverUrl + "/";
var actionUrl = window.serverUrl + "/";

if (window.vueDevMode === "development") {
  window.serverUrl = "http://localhost:8080";
  window.actionUrl = window.serverUrl + "/";
  actionUrl = window.serverUrl + "/";
} else if (window.vueDevMode === "production") {
  window.actionUrl = window.serverUrl + process.env.BASE_URL;
  actionUrl = window.serverUrl + process.env.BASE_URL;
}

window.$api = axios.create({
  baseURL: actionUrl,
  withCredentials: true
});
window.$api.interceptors.response.use((response) => {
  // emit event to refresh session timeout after every successful api call
  window.EventBus.$emit('refreshSessionTimeout');
  return response;
}, (error) => {
  return Promise.reject(error);
});

use([GridComponent, CanvasRenderer, TitleComponent, BarChart]);

Vue.component("v-chart", ECharts);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
